export const useProjectInfoLGUpViewLayout = visibleCards => {
  const financialCardIndex = visibleCards.findIndex(
    c => c?.key === 'financial'
  );

  const splitIndex = financialCardIndex !== -1 ? financialCardIndex : 4;

  return {
    secondColumnVisibleCards: visibleCards.slice(0, splitIndex),
    thirdColumnVisibleCards: visibleCards.slice(splitIndex)
  };
};
